import { runtime } from '../../../runtime/Runtime';
export class ImageThumb {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get image() {
        return this.parent;
    }
    get thumbApi() {
        if (runtime.isBot) {
            return '/api/thumb/?'; // pilbox:  https://github.com/agschwender/pilbox
        }
        return `https://${runtime.runtimeHostname.nodeHostName}/api/thumb/?`;
    }
    get naturalWidth() {
        return (this.image.img && this.image.img.naturalWidth_pixel) || 10;
    }
    get naturalSizeInBytes() {
        return (this.image.img && this.image.img.fileSize) || 1000000;
    }
    get thumbWidth() {
        const targetWidth = Math.ceil(this.image.essence.scaledValueOf.imageWidth / 100) * 100;
        if (this.naturalWidth > targetWidth * 1.3) {
            return targetWidth;
        }
        return 0;
    }
    get thumbSrc() {
        if (!this.thumbWidth || this.naturalSizeInBytes < 40000 || this.image.img.fileExtension === 'svg') {
            return this.image.img.src;
        }
        // e., height: image.essence.valueOf.height
        return `${this.thumbApi}url=${encodeURIComponent(this.image.img.src)}&w=${this.thumbWidth}`;
    }
    thumbSrcWithWidth(width = 200) {
        if (this.naturalSizeInBytes < 3000 || this.image.img.fileExtension === 'svg') {
            return this.image.img.src;
        }
        return `${this.thumbApi}url=${encodeURIComponent(this.image.img.src)}&w=${width}`;
    }
}
